export enum NavigationState {
    loggedIn,
    signUp,
    logIn
}
